// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/global-store'
import {getToken, removeToken, removeUserId} from './utils/authc'
import './permission'
// axios包装类
import axios from 'axios'
// 相关初始化样式、图标字体
import './common/stylus/index.styl'
// iView 框架
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
// 系统常量
import WpcConst from './utils/WpcConst.js'
// 图片放大插件
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import Print from '@/utils/print'
import vueCanvasPoster from 'vue-canvas-poster'
Vue.use(ViewUI)
Vue.use(WpcConst)
Vue.use(Print) // 注册
Vue.use(Viewer)
Vue.use(vueCanvasPoster)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

/*   *************************************** axios start ********************************* */
const baseUrl = process.env.API_BASE_URL
axios.interceptors.request.use(
  config => {
    // 如果存在token，则添加到请求头中
    config.headers.Authorization = getToken()
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    // 超时等待2.5秒
    config.timeout = 300000
    // 每个请求添加前缀
    config.baseURL = baseUrl
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
axios.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    console.log(error.response)
    if (error.response) {
      switch (error.response.status) {
        // 如果状态为401未授权，则清楚登陆token，返回登陆页
        case 401:
          removeToken()
          removeUserId()
          Vue.$router.push({name: 'Login'})
          window.location.reload()
          break
        // 如果状态为302（手动退出），则清楚登陆token，返回登陆页
        case 302:

          break
        // 如果状态为500（服务器抛出错误），则清楚登陆token，返回登陆页
        case 500:
          // 服务器抛出错误，返回500页面

          break
      }
    }
    return Promise.reject(error.response.data)
  }
)
// 绑定axios属性
Vue.prototype.$http = axios
/* *************************************** axios end **************************************** */
// 阻止生产提示
Vue.config.productionTip = false

/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

Math.signFigures = function (num, rank = 6) {
  if (!num) {
    return 0
  }
  const sign = num / Math.abs(num)
  const number = num * sign
  const temp = rank - 1 - Math.floor(Math.log10(number))
  let ans
  if (temp > 0) {
    ans = parseFloat(number.toFixed(temp))
  } else if (temp < 0) {
    ans = Math.round(number / Math.pow(10, temp)) * temp
  } else {
    ans = Math.round(number)
  }
  return (ans * sign)
}



// WEBPACK FOOTER //
// ./src/main.js